export default "__VITE_ASSET__CN8Twl4s__"